import { useState, useEffect } from "react";
import { commonActions } from "store/common";
import store from "store";
import { MstProcFeeItem, ProcFeeSelectRequest } from "../types/proc-fee";
import { fetchProcFees, updateProcFee } from "../api/procFeeApi";

const canUpdateField: (keyof MstProcFeeItem)[] = [
  "nitrogen_inflation_cost",
  "replac_labor_cost",
  "rubber_stem_valve_cost",
  "waste_tire_cost",
  "hub_rust_prevention_cost",
];

const shouldUpdate = (
  procFeeData: MstProcFeeItem,
  originalProcFeeData: MstProcFeeItem | undefined,
) => {
  if (!originalProcFeeData) return true;

  return canUpdateField.some(
    (key) =>
      procFeeData[key] !== originalProcFeeData[key] ||
      Number(procFeeData[key]) !== Number(originalProcFeeData[key]),
  );
};

/**
 * Custom hook to fetch and manage a paginated list of procedure fees.
 */
const useProcFeeList = () => {
  const [queryParams, setQueryParams] = useState<{
    store_cd: string;
    delete_flag: number;
  }>({
    store_cd: "",
    delete_flag: 1,
  });
  const [loading, setLoading] = useState(false);
  const [procFees, setProcFees] = useState<{ [key: number]: MstProcFeeItem }>();
  const [originalProcFees, setOriginalProcFees] = useState<{ [key: number]: MstProcFeeItem }>();
  const userType = localStorage.getItem("user_type");

  /**
   * @param body ProcFeeQuery
   */
  const getProcFees = async (body?: ProcFeeSelectRequest) => {
    setLoading(true);
    try {
      const { list } = await fetchProcFees(body);
      setProcFees(list);
      setOriginalProcFees(list);
    } catch (error) {
      // Notify?.setNotification({
      //   show: true,
      //   message: handleError(error),
      // });
    }
    setLoading(false);
  };

  const updateProcFeeItem = async (
    rimDiam: number,
    field: typeof canUpdateField[number],
    value: number,
    isCleared: boolean = false,
  ) => {
    const procFee = procFees && procFees[rimDiam];
    const originalProcFee = originalProcFees && originalProcFees[rimDiam];
    if (!procFee) return;
    if (!isCleared && !shouldUpdate(procFee, originalProcFee)) return;
    setLoading(true);
    store.dispatch(commonActions.setLoading());
    try {
      await updateProcFee({
        rim_diam: rimDiam,
        [field]: isCleared ? 0 : value,
        ...(isCleared && { column_delete_flag: 1 }),
      });
      await getProcFees();
    } catch (error) {
      // Notify?.setNotification({
      //   show: true,
      //   message: handleError(error),
      // });
    }
    setLoading(false);
    store.dispatch(commonActions.removeLoading());
  };

  useEffect(() => {
    getProcFees();
  }, []);

  return {
    procFees,
    originalProcFees,
    queryParams,
    loading,
    setQueryParams,
    setProcFees,
    setOriginalProcFees,
    updateProcFeeItem,
    userType,
  };
};

export default useProcFeeList;
